import { render } from "./BroadcastRegistrationFieldsEditor.vue?vue&type=template&id=170ac9af&scoped=true"
import script from "./BroadcastRegistrationFieldsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastRegistrationFieldsEditor.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastRegistrationFieldsEditor.vue?vue&type=style&index=0&id=170ac9af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170ac9af"],['__file',"src/components/Sites/Broadcast/BroadcastRegistrationFieldsEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "170ac9af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('170ac9af', __exports__)) {
    api.reload('170ac9af', __exports__)
  }
  
  module.hot.accept("./BroadcastRegistrationFieldsEditor.vue?vue&type=template&id=170ac9af&scoped=true", () => {
    api.rerender('170ac9af', render)
  })

}


export default __exports__